import { c as _c } from "react/compiler-runtime";
import { removeSplitTest } from 'modules/funnels/funnel/api/funnel-api';
import TabTable from 'modules/funnels/funnel/components/tab-table';
import { useFunnelStepTestsHistory } from 'modules/funnels/funnel/hooks/use-funnel-step-tests-history';
import { useSplitTestTableColumns } from 'modules/funnels/funnel/hooks/use-split-test-table-columns';
import TrashIcon from 'modules/funnels/funnel/icons/trash-icon';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getHistoryTableData } from 'modules/funnels/funnel/utils/split-tests-utils';
import React, { useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface SplitTestHistoryProps {
  funnelStep: FunnelStepInterface;
}
function SplitTestHistory(t0) {
  const $ = _c(23);
  const {
    funnelStep
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    testsHistoryData,
    mutateHistoryData
  } = useFunnelStepTestsHistory(funnelStep.id);
  const [isFetching, setIsFetching] = useState(false);
  const [isDeleteHistoryItemOpen, setIsDeleteHistoryItemOpen] = useState(false);
  const [historyItemIdToDelete, setHistoryItemIdToDelete] = useState(null);
  let t1;
  if ($[0] !== funnelStep.id || $[1] !== historyItemIdToDelete || $[2] !== mutateHistoryData) {
    t1 = async () => {
      if (!historyItemIdToDelete) {
        setIsDeleteHistoryItemOpen(false);
        return;
      }
      setIsFetching(true);
      const response = await removeSplitTest(funnelStep?.id, historyItemIdToDelete);
      await mutateHistoryData(response.data, false);
      setHistoryItemIdToDelete(null);
      setIsFetching(false);
    };
    $[0] = funnelStep.id;
    $[1] = historyItemIdToDelete;
    $[2] = mutateHistoryData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleDeleteHistoryItem = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      withEndDate: true,
      trashIconRenderer: data => <TrashIcon onClick={() => {
        setHistoryItemIdToDelete(data.splitTest.id);
        setIsDeleteHistoryItemOpen(true);
      }} className="hover:fill-red hover:border-red main-transition-colors ml-2 cursor-pointer" />
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const columns = useSplitTestTableColumns(t2);
  if (!testsHistoryData || isFetching) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Loader className="mb-10 mt-10 flex justify-center" />;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== columns || $[7] !== t || $[8] !== testsHistoryData) {
    const tableData = getHistoryTableData(testsHistoryData);
    t3 = tableData.length > 0 && <div className="flex flex-col gap-5 lg:px-8"><div className="text-text-primary font-inter text-center text-lg font-bold lg:text-xl">{t("dashboard.funnel.split_tests.history_header")}</div><div className="flex flex-col gap-4 lg:gap-20">{tableData.map((historyItem, index) => <TabTable columns={columns} data={historyItem} key={index} passDataToHeader={true} />)}</div></div>;
    $[6] = columns;
    $[7] = t;
    $[8] = testsHistoryData;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t) {
    t4 = t("dashboard.funnel.split_tests.remove_action_history_confirmation_text");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsDeleteHistoryItemOpen(false);
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("dashboard.funnel.split_tests.remove_action_history_toast");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== handleDeleteHistoryItem || $[16] !== isDeleteHistoryItemOpen || $[17] !== t4 || $[18] !== t6) {
    t7 = <Confirmation confirmationText={t4} opened={isDeleteHistoryItemOpen} onClose={t5} onConfirm={handleDeleteHistoryItem} toastCaption={t6} />;
    $[15] = handleDeleteHistoryItem;
    $[16] = isDeleteHistoryItemOpen;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t3 || $[21] !== t7) {
    t8 = <>{t3}{t7}</>;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
export default SplitTestHistory;